var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sh-button',_vm._b({attrs:{"size":_vm.size,"color":_vm.setColor,"target":_vm.target}},"sh-button",_vm._d({},[_vm.btnLinkKey,_vm.href,_vm.setStyle,true])),[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }